import * as React from 'react';
import {
    Box,
    List,
    ListItemButton,
    ListItemText
} from "@mui/material";
import {useAppDispatch, useAppSelector} from "../store/store";
import {changePage} from "../store/actions/actions";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";


export default function LeftNavigation() {
    const {t} = useTranslation()
    const page = useAppSelector((state:any) =>state.app.page)
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const handleListItemClick = (
        event: React.MouseEvent<HTMLDivElement, MouseEvent>,
        index: number,
    ) => {
        dispatch(changePage(index) as any)
    };
    return (
        <Box sx={{ width: '90%', maxWidth: 360, marginLeft: 2, bgcolor: 'white' }}>
            <List component="nav">
                <ListItemButton
                    selected={page === 0}
                    onClick={(event) => {
                        handleListItemClick(event, 0)
                        navigate("/")
                    }}
                >
                    <ListItemText primary={t('navigation.home' as any)} />
                </ListItemButton>
                <ListItemButton
                    selected={page === 1}
                    onClick={(event) => {
                        handleListItemClick(event, 1)
                        navigate("/simulation")
                    }}
                >
                    <ListItemText primary={t('navigation.simulation' as any)} />
                </ListItemButton>
                <ListItemButton
                    selected={page === 2}
                    onClick={(event) => {
                        handleListItemClick(event, 2)
                        navigate("/detail",{state:{type:"growth_model"}})
                    }}
                >
                    <ListItemText primary={t('navigation.growth_model' as any)} />
                </ListItemButton>
                <ListItemButton
                    selected={page === 3}
                    onClick={(event) => {
                        handleListItemClick(event, 3)
                        navigate("/detail",{state:{type:"urban_climate"}})
                    }}
                >
                    <ListItemText primary={t('navigation.urban_climate' as any)} />
                </ListItemButton>
                <ListItemButton
                    selected={page === 4}
                    onClick={(event) => {
                        handleListItemClick(event, 4)
                        navigate("/detail",{state:{type:"tree_species"}})
                    }}
                >
                    <ListItemText primary={t('navigation.european_cities' as any)} />
                </ListItemButton>
                <ListItemButton
                    selected={page === 5}
                    onClick={(event) => {
                        handleListItemClick(event, 5)
                        navigate("/detail",{state:{type:"structure"}})
                    }}
                >
                    <ListItemText primary={t('navigation.structure_growth' as any)} />
                </ListItemButton>
                <ListItemButton
                    selected={page === 6}
                    onClick={(event) => {
                        handleListItemClick(event, 6)
                        navigate("/detail",{state:{type:"ecosystem"}})
                    }}
                >
                    <ListItemText primary={t('navigation.ecosystem_page' as any)} />
                </ListItemButton>
                <ListItemButton
                    selected={page === 7}
                    onClick={(event) => {
                        handleListItemClick(event, 7)
                        navigate("/detail",{state:{type:"relevance"}})
                    }}
                >
                    <ListItemText primary={t('navigation.relevance_page' as any)} />
                </ListItemButton>
                <ListItemButton
                    selected={page === 8}
                    onClick={(event) => {
                        handleListItemClick(event, 8)
                        navigate("/detail",{state:{type:"recommendation"}})
                    }}
                >
                    <ListItemText primary={t('navigation.recommendation' as any )} />
                </ListItemButton>
                <ListItemButton
                    selected={page === 9}
                    onClick={(event) => {
                        handleListItemClick(event, 9)
                        navigate("/detail",{state:{type:"literature"}})
                    }}
                >
                    <ListItemText primary={t('navigation.literature' as any)} />
                </ListItemButton>
                <ListItemButton
                    selected={page === 10}
                    onClick={(event) => {
                        handleListItemClick(event, 10)
                        navigate("/detail",{state:{type:"glossary"}})
                    }}
                >
                    <ListItemText primary={t('navigation.glossary' as any)} />
                </ListItemButton>
                <ListItemButton
                    selected={page === 11}
                    onClick={(event) => {
                        handleListItemClick(event, 11)
                        navigate("/detail",{state:{type:"imprint"}})
                    }}
                >
                    <ListItemText primary={t('navigation.imprint' as any)} />
                </ListItemButton>
            </List>
        </Box>

    )
}
